<div class="ai-page">
  <div class="ai-header">
    <div>
      <h1>AI-BoQ</h1>
      <p>Generate a reviewable draft from a project or an existing BoQ. Create/Edit BoQ and auto-create stay as they are.</p>
    </div>
  </div>

  <div class="ai-card">
    <label class="field">
      <span class="field-label">Project</span>
      <select class="form-control" [(ngModel)]="selectedProjectId" (ngModelChange)="onProjectChange()">
        <option [ngValue]="null">Select a project</option>
        <option *ngFor="let project of projects" [ngValue]="project.id">
          {{ project.project_name }}
        </option>
      </select>
    </label>
    <label class="field">
      <span class="field-label">Existing BoQ (optional context)</span>
      <select class="form-control" [(ngModel)]="selectedBoqId" (ngModelChange)="onBoqChange()">
        <option [ngValue]="null">None</option>
        <option *ngFor="let boq of boqs" [ngValue]="boq.boq_id">
          {{ boq.boq_code }} — {{ boq.boq_name }}
        </option>
      </select>
    </label>
    <button type="button" class="primary-btn" (click)="generate()" [disabled]="loading">
      {{ loading ? 'Generating…' : 'Generate preview' }}
    </button>
  </div>

  <div class="ai-empty" *ngIf="!preview && !loading">
    Choose a project, then generate a preview. Nothing is saved until you create a draft.
  </div>

  <div class="ai-card stack" *ngIf="preview">
    <div class="summary">
      <div>
        <strong>{{ preview.project.project_name }}</strong>
        <span class="muted">
          · {{ preview.project.domain }}
          <ng-container *ngIf="preview.source_boq"> · context {{ preview.source_boq.boq_code }}</ng-container>
        </span>
      </div>
      <div class="totals">
        <span>{{ preview.totals.item_count }} items</span>
        <span>{{ formatInr(preview.totals.subtotal) }}</span>
      </div>
    </div>

    <ul class="rationale" *ngIf="preview.rationale?.length">
      <li *ngFor="let note of preview.rationale">{{ note }}</li>
    </ul>

    <div class="table-wrap">
      <table>
        <thead>
          <tr>
            <th>Source</th>
            <th>Code</th>
            <th>Description</th>
            <th>Qty</th>
            <th>Unit</th>
            <th>Rate</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of preview.items">
            <td>
              <span class="chip" [attr.data-source]="item.source">{{ sourceLabel(item) }}</span>
              <div class="muted" *ngIf="item.needs_confirm">confirm qty</div>
            </td>
            <td>{{ item.item_code }}</td>
            <td>
              <div>{{ item.item_description }}</div>
              <div class="muted" *ngIf="item.section_name">{{ item.section_name }}</div>
            </td>
            <td>{{ item.quantity | number:'1.0-2' }}</td>
            <td>{{ item.unit }}</td>
            <td>{{ formatInr(item.unit_rate) }}</td>
            <td>{{ formatInr(item.line_total) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="actions">
      <button type="button" class="primary-btn" (click)="saveDraft()" [disabled]="saving">
        Save as new draft BoQ
      </button>
    </div>
  </div>
</div>
